import React from 'react';
import { ModalFactory } from '../../../../components/modal/modal';
import {
  Stripe,
  StripeElements,
  StripeExpressCheckoutElementConfirmEvent
} from '@stripe/stripe-js';

import PaymentMethodRetryModal from '../../../../components/payment-method-retry-modal/PaymentMethodRetryModal';
import { getFlagValue, isFlagEnabled } from '../../../../redux/actions/flagsmith';
import { UNIFORM_REFERRAL_FLAG } from '../../../../utils/constants';

export const handleApplePayRetry = async (
  elements: StripeElements,
  content?: { heading?: string; description?: string }
) => {
  const { heading, description } = content || {};
  // @ts-ignore
  return await ModalFactory.builder(
    (onClose: any) => (
      <PaymentMethodRetryModal
        onClose={onClose}
        primaryButtonAction={() => initiatePaymentOnRetry(elements, onClose)}
        heading={heading}
        description={description}
      />
    ),
    'insta-modal center-modal',
    true
  );
};

export const handleStripeResponse = async (
  event: StripeExpressCheckoutElementConfirmEvent,
  stripe: Stripe,
  elements: StripeElements,
  submitPaymentMethod: Function,
  formValues: Record<string, any>
) => {
  const response = await stripe.createPaymentMethod({
    elements
  });

  if (response.error) {
    await handleApplePayRetry(elements);
    throw new Error(response.error.message);
  } else {
    const payload = { ...formValues, stripePaymentId: response.paymentMethod?.id };
    const submitResponse = await submitPaymentMethod(payload, false, false, true);
    if (!submitResponse.success) {
      await handleApplePayRetry(elements, {
        heading: submitResponse.errorTitle,
        description: submitResponse.errorBody
      });
      throw new Error('Payment Method Submission Failed');
    } else {
      return submitResponse;
    }
  }
};

export const initiatePaymentOnRetry = (
  elements: StripeElements,
  onClose: (flag: boolean) => void
) => {
  elements.getElement('expressCheckout')?.focus();
  const applePayWrapper = document.getElementById('stripe-apple-pay-wrapper');
  applePayWrapper?.scrollIntoView({ behavior: 'smooth' });
  onClose(true);
};

export const getIsUniformReferralEnabled = (countryCode: string, email: string): boolean => {
  if (!isFlagEnabled(UNIFORM_REFERRAL_FLAG)) return false;
  const countryConfig = getFlagValue(UNIFORM_REFERRAL_FLAG)?.[countryCode];
  if (!countryConfig) return false;
  const { whiteListedUsers = [] } = countryConfig;
  return whiteListedUsers.length > 0 ? whiteListedUsers.includes(email) : true;
};
